export default {
  SSR_GQL_ENDPOINT: process.env.SSR_GQL_ENDPOINT || 'http://localhost:5000/api',
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja8.kuikr.com',
  STATIC_FILE_PATH: process.env.STATIC_FILE_PATH || 'clsfd', // @Nikhil plz check if you need this??
  STATIC_DOMAIN: process.env.STATIC_DOMAIN || 'https://teja9.kuikr.com',
  APP_PORT: process.env.PORT || '3000',
  DOMAIN: process.env.DOMAIN || 'https://www.quikr.com',
  CF_IMG_DOMAIN: process.env.CF_IMG_DOMAIN || 'https://teja12.kuikr.com',
  QKR_RAVEN: process.env.QKR_RAVEN || 'https://raven.kuikr.com/upload',
  RAVEN_PROCESS: process.env.RAVEN_PROCESS || 'https://raven.kuikr.com/cf/ImageProcess.php',
  MAX_SIZE_IMAGE: process.env.MAX_SIZE_IMAGE || 4,
  GA4_ID: process.env.GA4_ID || 'G-TDXMWQ59FL'
};
